import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import App from '@src/screens/App'
import Home from '@src/screens/App/screens/Home'
import Auth from '@src/screens/App/screens/Auth'
import User from '@src/screens/App/screens/User'
import Booking from '@src/screens/App/screens/Booking'

import Service from '@src/screens/App/screens/Services/screens/Service'
import ModifyService from '@src/screens/App/screens/Services/screens/ModifyService'
import CancelService from '@src/screens/App/screens/Services/screens/CancelService'
import ChangeAliadaSearch from '@src/screens/App/screens/Services/screens/ChangeAliadaSearch'
import ChangeAliadaConfirm from '@src/screens/App/screens/Services/screens/ChangeAliadaConfirm'
import RescheduleService from '@src/screens/App/screens/Services/screens/Reschedule'
import RescheduleConfirm from '@src/screens/App/screens/Services/screens/RescheduleConfirm'

import ModifyRecurrence from '@src/screens/App/screens/Recurrences/screens/ModifyRecurrence'
import CancelRecurrence from '@src/screens/App/screens/Recurrences/screens/CancelRecurrence'
import RescheduleRecurrence from '@src/screens/App/screens/Recurrences/screens/RescheduleRecurrence'
import RescheduleRecurrenceConfirm from '@src/screens/App/screens/Recurrences/screens/RescheduleRecurrenceConfirm'
import ChangeRecurrenceAliadaSearch from '@src/screens/App/screens/Recurrences/screens/ChangeRecurrenceAliadaSearch'
import ChangeRecurrenceAliadaConfirm from '@src/screens/App/screens/Recurrences/screens/ChangeRecurrenceAliadaConfirm'

import ServiceSetup from '@src/screens/App/screens/Booking/screens/ServiceSetup'
import Search from '@src/screens/App/screens/Booking/screens/Search'
import AliadaProfile from '@src/screens/App/screens/Booking/screens/AliadaProfile'
import ServiceAddress from '@src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/screens/ServiceAddress'
import BookingConfirmation from '@src/screens/App/screens/Booking/screens/BookingConfirmation'
import Payment from '@src/screens/App/screens/Booking/screens/Payment'
import Success from '@src/screens/App/screens/Booking/screens/Success'
import ServiceInstructions from '@src/screens/App/screens/Booking/screens/ServiceInstructions'
import OrderConfirmation from '@src/screens/App/screens/Orders/screens/Confirmation'

import FourOhFour from '@src/screens/App/screens/404'
import UserProfile from '@src/screens/App/screens/UserProfile'
import UserServices from '@src/screens/App/screens/UserProfile/screens/UserServices'
import NextServices from '@src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices'
import EditProfile from '@src/screens/App/screens/UserProfile/screens/EditProfile'

import {
  onEnter as composeOnEnter,
  onChange as composeOnChange
} from './middleware/composeRouteHooks'
import requireAuth from './middleware/requireAuth'
import allowSameUserOrOperations from './middleware/allowSameUserOrOperations'
import setCurrentUserToUserId from './middleware/setCurrentUserToUserId'
import setCurrentUserToAuthedUser from './middleware/setCurrentUserToAuthedUser'
import redirectLoggedInUsersToNextServices from './middleware/redirectLoggedInUsersToNextServices'
import redirectToConfirmationIfNotFirstService from './middleware/redirectToConfirmationIfNotFirstService'
import redirectLoggedInUsers from './middleware/redirectLoggedInUsers'

const routes = (store) => {
  return (
    <Route path='/' component={App}>
      <IndexRoute component={Home} onEnter={redirectLoggedInUsersToNextServices(store)} />
      <Route path='hogar' component={Home} />
      <Route path='login' component={Auth} type='login' />
      <Route path='signup' component={Auth} type='signup' />

      <Route path='booking' component={Booking} onEnter={redirectLoggedInUsers(store)} onChange={redirectLoggedInUsers(store)}>
        <IndexRedirect to='configurar' />
        <Route path='configurar' component={ServiceSetup} />
        <Route path='busqueda' component={Search} />
        <Route path='aliadas/:aliadaId' component={AliadaProfile} />
        <Route path='aliadas/:aliadaId/reservar*' onEnter={requireAuth(store)} />
      </Route>

      <Route
        path='perfil/:userId'
        component={User}
        onEnter={
          composeOnEnter([
            requireAuth(store),
            allowSameUserOrOperations(store),
            setCurrentUserToUserId(store)
          ])
        }
        onChange={
          composeOnChange([
            requireAuth(store),
            allowSameUserOrOperations(store)
          ])
        }
        onLeave={setCurrentUserToAuthedUser(store)}
        >

        <IndexRedirect to='servicios/proximos' />

        <Route path='booking'>
          <Route path='configurar' component={ServiceSetup} />

          <Route path='busqueda' component={Search} />

          <Route path='aliadas/:aliadaId'>
            <IndexRoute component={AliadaProfile} />

            <Route path='reservar' onEnter={redirectToConfirmationIfNotFirstService(store)}>
              <Route path='direccion' component={ServiceAddress} />
              <IndexRoute component={BookingConfirmation} />
              <Route path='pagar' component={Payment} />
              <Route path='exito' component={Success} />
              <Route path='instrucciones' component={ServiceInstructions} />
            </Route>
          </Route>
        </Route>

        <Route component={UserProfile}>
          <Route path='servicios' component={UserServices}>
            <Route path='proximos' component={NextServices} />
          </Route>
          <Route path='editar' component={EditProfile} />
        </Route>

        <Route path='servicios'>
          <IndexRedirect to='servicios/proximos' />

          <Route path=':serviceId' component={Service}>
            <Route path='modificar' component={ModifyService} />

            <Route path='cambiar-aliada'>
              <Route path='buscar' component={ChangeAliadaSearch} />
              <Route path='confirmar' component={ChangeAliadaConfirm} />
            </Route>

            <Route path='cancelar' component={CancelService} />

            <Route path='reagendar'>
              <IndexRoute component={RescheduleService} />
              <Route path='confirmar' component={RescheduleConfirm} />
            </Route>
          </Route>
        </Route>

        <Route path='recurrencias'>
          <IndexRedirect to='servicios/proximos' />

          <Route path=':recurrenceId'>
            <Route path='modificar' component={ModifyRecurrence} />

            <Route path='cancelar' component={CancelRecurrence} />

            <Route path='reagendar'>
              <IndexRoute component={RescheduleRecurrence} />
              <Route path='confirmar' component={RescheduleRecurrenceConfirm} />
            </Route>

            <Route path='cambiar-aliada'>
              <Route path='buscar' component={ChangeRecurrenceAliadaSearch} />
              <Route path='confirmar' component={ChangeRecurrenceAliadaConfirm} />
            </Route>
          </Route>
        </Route>

        <Route path='comprar/producto/:productSlug' component={OrderConfirmation} />
      </Route>

      <Route path='*' component={FourOhFour} />
    </Route>
  )
}

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js